import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-23a19ef1")
const _hoisted_1 = { class: "app-form" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "header", {}, undefined, true),
    _createVNode(_component_el_form, { "label-width": _ctx.labelWidth }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItems, (item) => {
              return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
                key: item.label,
                span: 8
              }, _ctx.colLayout), {
                default: _withCtx(() => [
                  (!item.isHidden)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: item.label,
                        rules: item.rules,
                        style: _normalizeStyle(_ctx.itemStyle)
                      }, {
                        default: _withCtx(() => [
                          (!item.type || item.type === 'input' || item.type === 'password')
                            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                key: 0,
                                placeholder: item.placeholder
                              }, item.otherOptions, {
                                "show-password": item.type === 'password',
                                "model-value": _ctx.modelValue[`${item.field}`],
                                autocomplete: "off",
                                "onUpdate:modelValue": ($event: any) => (_ctx.handleValueChange($event, item.field))
                              }), null, 16, ["placeholder", "show-password", "model-value", "onUpdate:modelValue"]))
                            : (item.type === 'select')
                              ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                  key: 1,
                                  placeholder: item.placeholder
                                }, item.otherOptions, {
                                  style: {"width":"100%"},
                                  "model-value": _ctx.modelValue[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.handleValueChange($event, item.field))
                                }), {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (options) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: options.value,
                                        value: options.value,
                                        label: options.label
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1040, ["placeholder", "model-value", "onUpdate:modelValue"]))
                              : (item.type === 'datepicker')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                    key: 2,
                                    style: {"width":"100%"}
                                  }, item.otherOptions, {
                                    "model-value": _ctx.modelValue[`${item.field}`],
                                    "onUpdate:modelValue": ($event: any) => (_ctx.handleValueChange($event, item.field))
                                  }), null, 16, ["model-value", "onUpdate:modelValue"]))
                                : (item.type === 'custom')
                                  ? _renderSlot(_ctx.$slots, item.slotName, {
                                      key: 3,
                                      row: item
                                    }, undefined, true)
                                  : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "rules", "style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040))
            }), 128))
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["label-width"]),
    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
  ]))
}